import { Component, Signal, computed, inject, input } from '@angular/core';
import { Router } from '@angular/router';

import { I18nService } from '../../services/i18n.service';
import { UiService } from '../../services/ui.service';
import { Asset, AssetDetail } from '../../models/classes/asset';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { Sensor } from '../../models/classes/sensor';
import { LP_UI_CONFIG } from '../../core/tokens';
import { formatDistanceToNow } from 'date-fns';
import { de, enUS } from 'date-fns/esm/locale';

@Component({
  selector: 'app-tile',
  imports: [NzIconModule],
  templateUrl: './tile.html',
  styleUrls: ['./tile.scss'],
})
export class TileComponent {
  asset = input<Asset | AssetDetail | null>();
  sensor = input<Sensor | undefined>();

  telemetry = input<any | null>(null);
  isLeakageSensor = input<boolean>(false);
  isSteamTrap = input<boolean>(false);
  isSteamTrapInletOutlet = input<boolean>(false);
  steamtrap_outlet = input<any | null>(null);
  displayStyle = input<string>('');

  public cfg = inject(LP_UI_CONFIG);
  public i18n = inject(I18nService);
  private ui = inject(UiService);
  public router = inject(Router);

  // Signals for device type
  readonly isMobile: Signal<boolean> = computed(() => this.ui.IsMobile());
  readonly isTablet: Signal<boolean> = computed(() => this.ui.IsTablet());
  readonly isDesktop: Signal<boolean> = computed(() => this.ui.IsDesktop());

  IsRepairAndReplace = computed(() => {
    return this.displayStyle() === 'repair-and-replace';
  });

  Title = computed(() => {
    if (
      !!this.telemetry() &&
      !this.telemetry()?.critical &&
      !this.telemetry()?.warning &&
      // !this.telemetry()?.inactive &&
      !!this.telemetry()?.workingMessage
    )
      return this.telemetry()?.workingMessage;
    // if (
    //   !!this.telemetry &&
    //   this.telemetry()?.inactive &&
    //   !!this.telemetry()?.inactiveMessage
    // )
    //   return this.telemetry()?.inactiveMessage;
    if (!!this.telemetry && this.telemetry()?.critical && !!this.telemetry()?.criticalMessage)
      return this.telemetry()?.criticalMessage;
    if (!!this.telemetry && this.telemetry()?.warning && !!this.telemetry()?.warningMessage)
      return this.telemetry()?.warningMessage;

    return this.telemetry ? this.telemetry()?.title : 'telemetry data not found';
  });

  validTimeValue(timestamp: any) {
    try {
      this.minutesToNow(timestamp);
    } catch {
      return false;
    }
    return true;
  }
  minutesToNow(timestamp: any) {
    return formatDistanceToNow(timestamp, {
      locale: this.i18n.Lng() === 'de' ? de : enUS,
    }).replace('about ', '');
  }

  extraParsing(input: any) {
    // there's no pretty way to satisfy this weird design request...
    if (input === 'Working') return 'Working fine';
    else return input;
  }
}
